import { Inject } from '@angular/core';
import '@angular/compiler';
import { PagePolicyRecommendationComponent } from './page.policy.recommendation/page.policy.recommendation.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageRegionalAnalysisComponent } from './page.regional.analysis/page.regional.analysis.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageDataSourcesComponent } from './page.data.sources/page.data.sources.component';
import { ComponentRepresentativeRegionsComponent } from './component.representative.regions/component.representative.regions.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageSpecializationDistributionComponent } from './page.specialization.distribution/page.specialization.distribution.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePolicySimulatorComponent } from './page.policy.simulator/page.policy.simulator.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { ComponentPolicySimulatorComponent } from './component.policy.simulator/component.policy.simulator.component';
import { ComponentDashboardSummaryComponent } from './component.dashboard.summary/component.dashboard.summary.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { ComponentAnalysisNavigationComponent } from './component.analysis.navigation/component.analysis.navigation.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { ComponentRegionSelectorComponent } from './component.region.selector/component.region.selector.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PagePolicyRecommendationComponent,
        PortalSeasonFormDropdownComponent,
        PageRegionalAnalysisComponent,
        PageMypageComponent,
        PortalSeasonTreeComponent,
        PageMembersComponent,
        PageDataSourcesComponent,
        ComponentRepresentativeRegionsComponent,
        LayoutEmptyComponent,
        LayoutSidebarComponent,
        PagePostsItemComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonModalComponent,
        PageSpecializationDistributionComponent,
        PortalPostDetailComponent,
        PagePolicySimulatorComponent,
        PageDashboardComponent,
        PortalSeasonPaginationComponent,
        ComponentPolicySimulatorComponent,
        ComponentDashboardSummaryComponent,
        ComponentNavSidebarComponent,
        ComponentAnalysisNavigationComponent,
        PagePostsComponent,
        ComponentRegionSelectorComponent,
        PageAccessComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalPostListComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }